import React, { Component } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import ReactHtml from "raw-html-react";
import "./Banner.css";
class Banner1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: [],
      sub: [],
      single: [],
    };
  }
  componentDidMount() {
    axios
      .get(
        encodeURI(
          process.env.REACT_APP_API_URL + "api/resource/Homepage Section/Banner"
        ),
        {
          headers: {
            Authorization: process.env.REACT_APP_TOKEN,
            "content-type": "application/json",
          },
        }
      )
      .then((response) => {
        this.setState({ menu: response.data["data"] });
        //console.log(response.data['data'])
      });
  }
  render() {
    return (
      <div>
        <div class="banner-section section img " /* style={{"marginTop":"112px"}} */>
          <div class="container">
            <ReactHtml html={this.state.menu["section_html"]} />
          </div>
        </div>
      </div>
    );
  }
}
export default Banner1;
